var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.$emit('update:visible', true);
      }
    }
  }, [_vm._t("action")], 2), _c('ElDialog', {
    attrs: {
      "visible": _vm.visible,
      "width": _vm.width,
      "title": _vm.title,
      "center": ""
    },
    on: {
      "update:visible": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('ElButton', {
          on: {
            "click": _vm.close
          }
        }, [_vm._v("取 消")]), _c('ElButton', {
          attrs: {
            "type": "primary",
            "loading": _vm.isSubmitting
          },
          on: {
            "click": _vm.confirm
          }
        }, [_vm._v(" 确 定 ")])];
      },
      proxy: true
    }])
  }, [_c('ElForm', _vm._b({
    ref: "form",
    attrs: {
      "size": "small",
      "label-position": "right"
    }
  }, 'ElForm', _vm.$attrs, false), [_vm._t("default")], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };